export default "__VITE_ASSET__Bolw26qL__"